import script from "./ProductCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCard.vue?vue&type=style&index=0&id=54d07582&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d07582"]])

export default __exports__